import React from "react";

import {
    CreatorInfoLayout,
    CreatorName,
    CreatorCountry,
    CreatorAvatar,
    CreatorNameAndCountryLayout
} from "./styles";

const CreatorInfo = ({
    creatorName,
    creatorCountry,
    creatorAvatarUrl,
    creatorProfilePath
}) => {
    return (
        <CreatorInfoLayout>
            <CreatorAvatar
                href={creatorProfilePath}
                avatarSrc={creatorAvatarUrl}
                alt={`${creatorName} Avatar`}
            />
            <CreatorNameAndCountryLayout>
                <CreatorName href={creatorProfilePath}>
                    {creatorName}
                </CreatorName>

                {!!creatorCountry && (
                    <CreatorCountry>{creatorCountry}</CreatorCountry>
                )}
            </CreatorNameAndCountryLayout>
        </CreatorInfoLayout>
    );
};

export default CreatorInfo;
